import { apiSlice } from "../apiSlice";
import { TEACHERQUESTIONS_URL } from "../../constants";

export const teacherQuestionsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTeacherNewQuestions: builder.query({
            query: ({ pageNumber }) => ({
                url: `${TEACHERQUESTIONS_URL}/newteacherquestions`,
                params: {
                    pageNumber,
                },
            }),
            providesTags: ['Questions'], 
        }),
        getTeacherNewQuestion: builder.query({
            query: (id) => ({
                url: `${TEACHERQUESTIONS_URL}/newteacherquestion/${id}`,
            }),
        }),
        getTeacherAnswerByQuestion: builder.query({
            query: (id) => ({
                url: `${TEACHERQUESTIONS_URL}/getteacheranswerbyquestion/${id}`,
            }),
        }),
        getTeacherAnswer: builder.query({
            query: (id) => ({
                url: `${TEACHERQUESTIONS_URL}/getteacheranswer/${id}`,
            }),
        }),
        newAnswer: builder.mutation({
            query: (data) => ({
              url: `${TEACHERQUESTIONS_URL}/teachernewanswer`,
              method: 'POST',
              body: data,
            }),
        }),
        callOpenApi: builder.query({
            query: (id) => ({
              url: `${TEACHERQUESTIONS_URL}/callopenapi/${id}`,
            }),
        }),
        updateQuestionWatched: builder.mutation({
            query: (id) => ({
              url: `${TEACHERQUESTIONS_URL}/updatequestionwatched/${id}`,
              method: 'PUT',
            }),
            invalidatesTags: ['Questions'], // Invalidate 'Questions' cache upon success
        }),
        getTeacherAllQuestions: builder.query({
            query: (id) => ({
                url: `${TEACHERQUESTIONS_URL}/teacherallquestions/${id}`,
            }),
        }),
        getTeacherAllAnswers: builder.query({
            query: (id) => ({
                url: `${TEACHERQUESTIONS_URL}/teacherallanswers/${id}`,
            }),
            providesTags: ['Answers'], 
        }), 
        updateAnswerMedia: builder.mutation({
            query: (data) => ({
              url: `${TEACHERQUESTIONS_URL}/updateanswermedia`,
              method: 'POST',
              body: data,
            }),
        }),
        getallqanda: builder.query({
            query: ({id, pageNumber}) => ({
                url: `${TEACHERQUESTIONS_URL}/getallqanda`,
                params: {
                    id,
                    pageNumber,
                },
            }),
            providesTags: ['Questions', 'Answers'], 
        }),                 
    }),
});

export const { useGetTeacherNewQuestionsQuery, useCallOpenApiQuery, useUpdateAnswerMediaMutation, useUpdateQuestionWatchedMutation, useGetTeacherNewQuestionQuery, useGetTeacherAnswerByQuestionQuery, useNewAnswerMutation, useGetTeacherAllQuestionsQuery, useGetTeacherAllAnswersQuery, useGetTeacherAnswerQuery, useGetallqandaQuery   } = teacherQuestionsApiSlice;